module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_50m Lap Pool_RGB_lr.cedd7a87.jpg";